import constants from 'lib/constants';
import Framework from "framework";

function getNBAMServiceControl(serviceClass,callMultiContainer) {

	var serverHostname = "localhost";

	var serviceClass = serviceClass;
	var callMultiContainer = callMultiContainer;
	var offerLength = 0;
  	var NBAMServiceControl = {

		hostName : serverHostname,
		url : "",

		initialize : function (serverHostname) {
			this.hostName = serverHostname;
			if (typeof this.hostName == 'undefined')
				this.hostName = window.lt.api.apimUrl;

			this.url = this.hostName  + "dengine/PegaMKTContainer/Services/ExecuteWebContainer?";

		},

		getServiceURL : function (serviceName, params) {
			var url;
			if(serviceClass){
				url = this.hostName  + "dengine/PegaMKTContainer/"+serviceClass+"/"+serviceName+"?";

			} else {
				var url = this.hostName  + "dengine/PegaMKTContainer/Services/"+serviceName+"?";
			}

			if(params != null) {
			 url += params;
			}
			console.log('Returning URL: ' + url );
			return url;

		},

		getOffers : function (customerID, containerName, channel, previousPage, currentpage, callback, clubID, errorCallback) {

			this.checkCallBack(callback);
			var callbackFunction ;



			if(callMultiContainer){
				callbackFunction = function (data){
				    var responseData = data['ContainerList'];
					var containerNameList = containerName.split(",");
					for(var i=0;i<containerNameList.length;i++){
						callback(containerNameList[i], responseData[i], customerID);
					}
				};
			}
			else
				callbackFunction = callback;

			var jsonObj = this.getJSONObj(customerID, containerName, channel, previousPage, currentpage, clubID);

			if(serviceClass){
				this.invokeRemoteService("Container",null,"POST",jsonObj,callbackFunction,errorCallback);
			} else {
				this.invokeRemoteService("ExecuteWebContainer",null,"POST",jsonObj,callbackFunction,errorCallback);
			}

		},

    loadOffers : function (jsonObj, methodType, callback) {

			this.checkCallBack(callback);
			if(methodType == "GET"){
			    var queryParams = function parse(jsonObj) {
									return '?' +
									Object.keys(jsonObj).map(function(key) {
									if(typeof jsonObj[key]!='object'){
										return encodeURIComponent(key) + '=' +
										encodeURIComponent(jsonObj[key]);
										}
									}).join('&');}
          queryParams = queryParams.substring(0, queryParams.length() - 1);
				  this.invokeRemoteService("Container", queryParams,"GET", null, callback);
			}
			else {
				  this.invokeRemoteService("Container", null,"POST", jsonObj, callback);
			}

		},

		getJSONObj : function(customerID, containerName, channel, previousPage, currentpage, clubID){
			if(serviceClass){
				var jsonObj = {
					"CustomerID" : String(customerID),
					"ContainerName" : containerName,
					"Channel": channel,
                  	"Contexts": [{
                                  "Key": "CurrentPage",
                                  "Value": currentpage,
                                  "Type": "CurrentPage"
                             	 },
                                 {
                                  "Key": "PreviousPage",
                                  "Value": previousPage,
                                  "Type": "PreviousPage"
                             	 },
								 {
									"Key": "CurrentClubID",									
									"Value": String(clubID),
									"Type": "Intent"									
								 }]
				};
			} else {
				var jsonObj = {
					"CustomerID" : customerID,
					"ContainerName" : containerName,
					"Channel": channel,
					"PreviousPage":previousPage,
					"CurrentPage":currentpage
			    };
			}
			return jsonObj;
		},

		captureResponseLT : function (ContainerID, CustomerID, pegaObj){
			let serviceUrl = this.getServiceURL("CaptureResponse", null);	
			console.log(' called Capture Response');
			const jsonObjc = {
				"ContainerName": ContainerID,
				"CustomerID": String(CustomerID),
				"RankedResults": [{
						"InteractionID": pegaObj.InteractionID,
						"Identifier": pegaObj.Identifier,            
						"Issue": pegaObj.Issue,
						"Group": pegaObj.Group,
						"Name": pegaObj.Name,
						"Rank": pegaObj.Rank,
						"Channel": pegaObj.Channel,
						"Outcome": "Clicked"
					}
				]
			};

			console.log('before call getServiceURL');
					
			console.log('Using Service URL -> '+ serviceUrl);
			const textData = JSON.stringify(jsonObjc);
			console.log('textData -->'+textData);
			const callbackFunction = function(data){
				// do nothing on success
			}
			const errorFunction = function(data){
				// do nothing on error
			}
			var xmlHttpReq = this.createRequest("POST", serviceUrl, callbackFunction, errorFunction);
			if (xmlHttpReq)	{
				xmlHttpReq.send(textData);
			}


		},

		/* "captureSingleWebImpression " : to capture single web impression, pass following parameters and the impression would be captured.*/
		captureSingleWebImpression : function (ContainerID, CustomerID, OfferID, Issue, Group, InteractionID, campaignID,callback) {
			var jsonObj = {
				"CustomerID" : CustomerID,
				"ContainerName" : ContainerID,
				"OffersList" : [{
						"OfferID" : OfferID,
						"Issue" : Issue,
						"Group" : Group,
						"InteractionID" : InteractionID,
						"CampaignID": campaignID
					}
				]
			};

			this.captureMultipleWebImpression(jsonObj, callback);
		},

		/**
		* "captureMultipleWebImpression" :
		* Accepts the JSON Object with the list of offers and then captures the impressions for all the offers
		**/
		captureMultipleWebImpression : function (JSONObj, callback) {
			var jsonString = JSON.stringify(JSONObj);
			var serviceUrl = this.getServiceURL("CaptureWebImpression",null);
			var xmlHttpReq = this.createRequest('POST', serviceUrl, callback);
			if (xmlHttpReq)	xmlHttpReq.send(jsonString);
		},

      	/**
		*"capturePaidClickResponse " : capture paid media click response
		**/
		capturePaidClickResponse : function (CustomerID, ExternalAudienceId, ReferrerUrl, Utm_medium, callback) {
			var jsonObj = {
				"CustomerID" : CustomerID,
				"ExternalAudienceId" : ExternalAudienceId,
				"ReferrerUrl" : ReferrerUrl,
				"Utm_medium" : Utm_medium
			};

			this.captureMultiplePaidClickResponse(jsonObj, callback);
		},
    /**
		*"capturePaidClickResponse " : capture paid media click response with AdSetId and DestinationType
		**/
		capturePaidClickResponseExt : function (CustomerID, ExternalAudienceId, AdSetId, DestinationType, ReferrerUrl, Utm_medium, Outcome, callback) {
			var jsonObj = {
				"CustomerID" : CustomerID,
				"ExternalAudienceId" : ExternalAudienceId,
				"ReferrerUrl" : ReferrerUrl,
				"Utm_medium" : Utm_medium,
        "AdSetId" : AdSetId,
        "DestinationType" : DestinationType,
        "Outcome" : Outcome
			};

			this.captureMultiplePaidClickResponse(jsonObj, callback);
		},

    /**
		 * Fetches the query parameters from the click URL.
		 */
		fetchQueryParams: function () {
			return window.location.search.substring(1);
		},

		/**
		 * Builds the request payload required for the CapturePaidResponseExt service and also identifies the destination
		 * i.e., Facebook/Google based on the query parameter name adset_id/adgroup_id
		 */
		buildRequestPayload: function () {
			var rawQueryParams = sessionStorage.getItem('query_params');
			var queryParams = rawQueryParams.split('&');
			var externalAudienceId, adSetIdOrAdGroupId, utmMedium, outcome, referralUrl, destination;
			if (queryParams) {
				for (var i = 0; i < queryParams.length; i++) {
					console.log(queryParam);
					var queryParam = queryParams[i];
					var key = queryParam.split('=')[0];
					var value = queryParam.split('=')[1];
					switch (key) {
						case 'ext_aud_id':
							externalAudienceId = value;
							break;
						case 'adset_id':
							adSetIdOrAdGroupId = value;
							destination = 'Facebook';
							break;
						case 'adgroup_id':
							adSetIdOrAdGroupId = value;
							destination = 'Google';
							break;
						case 'utm_medium':
							utmMedium = value;
							break;
						case 'outcome':
							outcome = value;
							break;
						case 'ref_url':
							referralUrl = value;
							break;
					}
				}
			}
			if (!outcome || outcome.length <= 0) {
				outcome = "PaidClick";
			}
			return {
				'externalAudienceId': externalAudienceId,
				'adSetIdOrAdGroupId': adSetIdOrAdGroupId,
				'utmMedium': utmMedium,
				'outcome': outcome,
				'referralUrl': referralUrl,
				'destination': destination
			}
		},

		/**
		* "captureMultiplePaidClickResponse" capture paid meida click response
		**/
		captureMultiplePaidClickResponse : function (JSONObj, callback) {
			var jsonString = JSON.stringify(JSONObj);
			var serviceUrl = this.getServiceURL("CapturePaidResponse",null);
			var xmlHttpReq = this.createRequest('POST', serviceUrl, callback);
			if (xmlHttpReq)	xmlHttpReq.send(jsonString);
		},
		// Create the XHR object.
	 createRequest : function(method, url, callback,errorCallback) {
		var xhr = new XMLHttpRequest();
		if (typeof xhr == "undefined") { return null; }

		xhr.onreadystatechange = function () {
			//if (xhr.readyState == 4 && xhr.status == 200) {
			if (xhr.readyState == 4 ) {
				var data = xhr.responseText;

				if (data && typeof callback == "function") {
					try {

						callback(JSON.parse(data));
					} catch (exception) {}
				}
			}
		};
		//Set timeout value of 3 seconds
		if(Framework.global.lt.pageProperties.pegaServiceTimeout){
			xhr.timeout = Framework.global.lt.pageProperties.pegaServiceTimeout;
		} else {
			xhr.timeout = constants.pegaServiceTimeout;
		}
		xhr.onerror = function ( eventObj) {
			console.log('Error Function');
			errorCallback({
				status :'error',
				source : 'xhr',
				xhrStatus : xhr.status,
				errorObj: eventObj
			});
		};
		xhr.ontimeout = function (eventObj) {
			console.log('Timeout detected');
			errorCallback({
				status: 'error',
				source: 'timeout',
				xhrStatus : xhr.status,
				errorObj: eventObj
			});
		}
		xhr.open(method, url, true);
		xhr.setRequestHeader("ocp-apim-subscription-key", window.lt.api.apimKey);
		return xhr;
	},

	checkCallBack : function(callback) {

		if (callback == null  || typeof callback == 'undefined') {
			callback = this.callDefaultCallBack;
		}
	},

	callDefaultCallBack : function (response) {

		var OffersList;
	 	if(typeof response.OffersList != "undefined") {
			OffersList = response.OffersList;
		} else if(data.RankedResults && data.RankedResults.length) {
			OffersList = response.RankedResults;
		}


		for (var i=0; i< OffersList.length; i++) {
		      //Get the src for the img tag...
		      var ba = document.getElementById("BannerAd" + (offerLength+i));
		      var tagname = "BannerURL";
		      if (ba && $(ba).hasClass("smimg")) {
		         tagname = "BannerURLSmall";
		      }

			  offerLength = offerLength+i;

		      var bannerURL = OffersList[i].ImageURL;
			  var n = str.indexOf("content/");
			 var imgURL = str.substring(0, n);
			  var repoURL = imgURL + "content";
			  //Get the content for the fragment ...
			  var contentformat = OffersList[i].ContentFormat;
	if(contentformat == "HTML")
	{
	  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      var str = this.responseText;
	  alert(this.responseText);
	  var res = str.replace("/content",repoURL);
      // Need to update the code for Dynamic Div to support fragmants will be taking care as part of uplus bank code changes
	  document.getElementById("BannerAd_Frag").innerHTML = res;
	  alert(res);
	}
	else{

			  $(function(){
      $("#includedContent").load(bannerURL+".html");
    });
		      if (ba) ba.src = bannerURL;

		      //Get the href for the anchor/link tag
		      var bannerRef = OffersList[i].ClickThroughURL;


		      var bc = document.getElementById("BannerClick" + i);
		      if (bc) bc.href = bannerRef;
	   	}
  }


  };
  xhttp.open("GET", bannerURL, true);
  xhttp.send();
}},

	/* captureWebResponse function is implemented as part US-81885 */

	captureWebResponse : function (containerID, customerID, offerID, issue, group, interactionID,outcome,behaviour,channel,direction,campaignID,callback) {

		var jsonObj = {
			"CustomerID" : customerID,
			"ContainerName" : containerID,
			"OffersList" : [{
					"OfferID" : offerID,
					"Issue" : issue,
					"Group" : group,
					"CampaignID": campaignID,
					"InteractionID" : interactionID,
					"Outcome":outcome,
					"Behaviour":behaviour,
					"Direction":direction,
					"Channel":channel

				}]
		};
		this.captureWebResponseWithJSON(jsonObj,callback);

	},
	captureWebResponseWithJSON : function(jsonObj,callback){
		this.invokeRemoteService("CaptureWebResponse",null,"POST",jsonObj,callback);
    },
	captureResponse : function(containerID, customerID, offerID, issue, group, interactionID,outcome,behaviour,channel,direction,campaignID,callback,initiateOffer){


		if(serviceClass){
			var jsonObj = {
				"CustomerID" : customerID,
				"ContainerName" : containerID,
				"RankedResults" : [{
						"Name" : offerID,
						"Issue" : issue,
						"Group" : group,
						"CampaignID": campaignID,
						"InteractionID" : interactionID,
						"Outcome":outcome,
						"Behaviour":behaviour,
						"Direction":direction,
						"Channel":channel

				}]
			};
		} else {
			var jsonObj = {
				"CustomerID" : customerID,
				"ContainerName" : containerID,
				"OffersList" : [{
						"OfferID" : offerID,
						"Issue" : issue,
						"Group" : group,
						"CampaignID": campaignID,
						"InteractionID" : interactionID,
						"Outcome":outcome,
						"Behaviour":behaviour,
						"Direction":direction,
						"Channel":channel

				}]
			};
		}

		this.captureResponseWithJSON(jsonObj,callback,initiateOffer);
	},
	captureResponseWithJSON : function(jsonObj,callback,initiateOffer){
		if(serviceClass){
			if(initiateOffer){
				this.invokeRemoteService("CaptureResponse/Initiate",null,"POST",jsonObj,callback);
			} else {
				this.invokeRemoteService("CaptureResponse",null,"POST",jsonObj,callback);
			}
		} else{
			this.invokeRemoteService("CaptureResponse",null,"POST",jsonObj,callback);
		}

    },

	invokeRemoteService: function(serviceName,urlParams,httpVerb,jsonObj,callback, errorCallback){
		var serviceUrl = this.getServiceURL(serviceName,urlParams);
		var xmlHttpReq = this.createRequest(httpVerb, serviceUrl, callback,errorCallback);
		if (xmlHttpReq)	xmlHttpReq.send(JSON.stringify(jsonObj));
	},

  };

    return NBAMServiceControl;
}
//static-content-hash-trigger-YUI

var returnVal = {
	getNBAMServiceControl: getNBAMServiceControl
};

export default returnVal;
